import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  // 1. @/*/locales 폴더 하위의 json 파일 가져오기
  const locales = require.context(
    "@",
    true,
    /locales\/[A-Za-z0-9-_,\s]+\.json$/i
  );

  // 2. 국가별로(ko, ja, en) json파일 구별하여 합치기
  const messages = {};
  locales.keys().forEach((key) => {
    // 2_1. locales 뒤의 2글자 가져옴
    const matched = key.match(/locales\/([A-Za-z0-9-_]{2})./i);
    // 2_2. 국가코드별 메세지구별
    if (matched && matched.length > 1) {
      const locale = matched[1];

      // 3_1. 추가할 Message (= addMessage)
      let addMessage = locales(key);

      // 3_2 기존 Messages에 저장된 내용
      let message = {};
      if (messages[locale] != undefined) {
        message = messages[locale];
      }

      // 3_3 key값이 동일한 경우 별도로 합침
      Object.keys(addMessage).forEach((key) => {
        if (addMessage[key] && message[key]) {
          let addApp = addMessage[key];
          let msgApp = message[key];
          Object.keys(addApp).forEach((a) => {
            Object.keys(msgApp).forEach((m) => {
              if (a == m) {
                Object.assign(addApp[a], msgApp[a]);
              }
            });
          });
        }
      });

      // 3_4. 그외 모든 메세지 합침
      let resultMessage = Object.assign(message, addMessage);

      // 4. 합쳐진 메세지로 대체
      messages[locale] = resultMessage;
    }
  });
  return messages;
}

const dateTimeFormats = {
  en: {
    yyyymm: {
      year: "numeric",
      month: "short",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    shortWithWeekDay: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
    longtime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    },
  },
  ja: {
    yyyymm: {
      year: "numeric",
      month: "short",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    shortWithWeekDay: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
    longtime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    },
  },
  ko: {
    yyyymm: {
      year: "numeric",
      month: "short",
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    shortWithWeekDay: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
    time: {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
    longtime: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    },
  },
};

const numberFormats = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
    },
  },
  "ja-JP": {
    currency: {
      style: "currency",
      currency: "JPY",
      currencyDisplay: "symbol",
    },
  },
  "ko-KR": {
    currency: {
      style: "currency",
      currency: "KRW",
      currencyDisplay: "symbol",
    },
    none: {
      currency: "KRW",
      currencyDisplay: "symbol", // symbol, name(대한민국 원)
    },
  },
};

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "ko",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "ko",
  messages: loadLocaleMessages(),
  dateTimeFormats,
  numberFormats,
});
